import { NotificationItem } from '../../types'

const checkNotificationType = (notification: NotificationItem) => {
  const isQuote = notification.type === 'REPOST' && notification.post?.text
  const isReply = notification.type === 'COMMENT'
  const isLike = notification.type === 'LIKE'
  const isFollowRequest = notification.type === 'FOLLOW_REQUEST'
  const isUnread = notification.status === 'UNREAD'

  const isFollow = notification.type === 'FOLLOW'
  const isFollowingRelated = isFollow || isFollowRequest

  const isEventRelated =
    notification.type === 'EVENT_INVITE' ||
    notification.type === 'EVENT_JOIN' ||
    notification.type === 'EVENT_CANCEL' ||
    notification.type === 'EVENT_UPDATE'

  return {
    isLike,
    isQuote,
    isReply,
    isUnread,
    isFollow,
    isEventRelated,
    isFollowRequest,
    isFollowingRelated,
  }
}

export default checkNotificationType
